import { FC } from "react"
import * as React from "react"

import { brand } from "config/brand"
import * as styles from "./styles.module.scss"
import iconCall from "./img/icon-call.svg"
import iconEmail from "./img/icon-email.svg"

const Contacts: FC = () => {
  return (
    <ul className={styles.contacts}>
      <li className={styles.item}>
        <a className={styles.link} href="mailto:hello@better.com">
          <i className={styles.icon}>
            <img className={styles.image} src={iconEmail} alt="Email" />
          </i>
          <div className={styles.message}>
            <h6 className={styles.eyebrow}>Email us</h6>
            <h4 className={styles.contact}>hello@better.com</h4>
          </div>
        </a>
      </li>
      <li className={styles.item}>
        <a className={styles.link} href={`tel:${brand.phone}`}>
          <i className={styles.icon}>
            <img className={styles.image} src={iconCall} alt="Call" />
          </i>
          <div className={styles.message}>
            <h6 className={styles.eyebrow}>Call us</h6>
            <h4 className={styles.contact}>{brand.phone}</h4>
            <small className={styles.phoneDisclaimer}>
              Not for use by New York borrowers
            </small>
          </div>
        </a>
      </li>
    </ul>
  )
}

export default Contacts
